export default "__VITE_ASSET__BSmLRl5u__"